import * as React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { VariantName, animations } from './animations'
import { GatsbyImage } from 'gatsby-plugin-image'
import { IImage } from '../../../graphql/types'

const DELAY_MS = 3000

const StyledImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  font-size: 0;
`

const StyledImageWrapper = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
`

export type SlideshowProps = {
  images: IImage[]
  variant: VariantName
}

export const Slideshow = ({ images, variant }: SlideshowProps) => {
  const [page, setPage] = useState(0)

  useEffect(() => {
    setTimeout(() => {
      setPage((prevPage) => (prevPage === images.length - 1 ? 0 : prevPage + 1))
    }, DELAY_MS)
  }, [page])

  return (
    <StyledImageContainer>
      <AnimatePresence>
        <StyledImageWrapper
          key={page}
          variants={animations[variant]}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { duration: 0.8, ease: [0.7, 0, 0.3, 1] },
            y: { duration: 0.8, ease: [0.7, 0, 0.3, 1] },
          }}
        >
          <GatsbyImage
            image={images[page].image.gatsbyImageData}
            alt={images[page].alternativeText}
          />
        </StyledImageWrapper>
      </AnimatePresence>
    </StyledImageContainer>
  )
}
